import { useEffect } from 'react';

import ResourceSections from '../../../molecules/Desktop/ResourceProviders/ResourceSections';


const ResourceProviders = () => {
  useEffect(() => {
    document.title = `HomeCook | Resource Providers`;
  }, []);

  return (
    <>
      <ResourceSections />
    </>
  );
};

export default ResourceProviders;
